export const START_PAGE = "START_PAGE";
export const CANCEL_BOOKING_PAGE = "CANCEL_BOOKING_PAGE";
export const EDIT_BOOKING_PAGE = "EDIT_BOOKING_PAGE";
export const ACCEPT_PAYMENT_PAGE = "ACCEPT_PAYMENT_PAGE";
export const TIPS_PAGE = "TIPS_PAGE";
export const NO_SHOW_PAGE = "NO_SHOW_PAGE";
export const TOGGLE_CONFIRMATION_PAGE = "TOGGLE_CONFIRMATION_PAGE";
export const MOVE_BOOKING_TECHNICIAN_PAGE = "MOVE_BOOKING_TECHNICIAN_PAGE";
